import { svg } from 'lit';

const symbol = svg`<svg width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 2v10.5M13.334 5L10 1.665 6.667 4.999M3.333 10v8.333h13.333V10" stroke="#000" stroke-width=".9" stroke-linecap="square" stroke-linejoin="round"/></svg>`;

export { symbol as default };
